import { Checkbox } from '@wartek-id/checkbox-v1'
import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'

type DialogConsentDinasProps = {
  value: string
  children?: React.ReactNode
  isDisabled: boolean
  onConsentChange?: (isAccepted: boolean) => void
}

export const DialogConsentDinas: FC<DialogConsentDinasProps> = ({
  value,
  children,
  isDisabled = false,
  onConsentChange,
}) => {
  return (
    <div className="space-y-4">
      <Text variant="display-sm">Lanjut dinilai oleh Dinas Pendidikan?</Text>
      <Text color="subdued" className="!font-normal">
        Jika data Tim Kerja (Pengawas Sekolah) Anda salah, Pengelolaan Kinerja
        Anda akan dinilai oleh Dinas Pendidikan di daerah Anda.
      </Text>

      <div className="flex flex-row gap-2 items-center justify-between rounded border border-subdued p-4 bg-surface-subdued">
        <Text color="subdued" className="flex-1">
          Daerah Dinas Pendidikan
        </Text>
        <Text className="!font-normal flex-1 text-right truncate">{value}</Text>
      </div>

      <Checkbox
        disabled={isDisabled}
        labelPosition="center"
        onChange={(e) => onConsentChange?.(e?.target?.checked || false)}
      >
        Saya mengerti Pengelolaan Kinerja saya akan dinilai oleh Dinas
        Pendidikan di daerah saya.
      </Checkbox>

      {children}
    </div>
  )
}
